import PropTypes from 'prop-types';
import React from 'react';
import { Table } from 'antd';
import { generateDailySnapshotColumns } from './weathers.constants';
import HourlyConditions from './HourlyConditions';

const renderHourlyConditions = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <HourlyConditions {...props} />
);

export default function DailySnapshotTable({ data = [], loading, startHour, endHour } = {}) {
  const columns = generateDailySnapshotColumns(renderHourlyConditions, startHour, endHour);

  return (
    <Table
      style={{ width: '100%' }}
      title={() => 'Daily Snapshot'}
      pagination={false}
      loading={loading}
      columns={columns}
      dataSource={data}
      bordered
    />
  );
}

DailySnapshotTable.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  startHour: PropTypes.number,
  endHour: PropTypes.number,
};

DailySnapshotTable.defaultProps = {
  data: [],
  loading: false,
  startHour: 6,
  endHour: 21,
};
